let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("guizK")).then(() => parcelRequire('7fskd'));